import { LAYOUTS } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
export const template = (height) => ({
    layout: {
        id: ROUTE.KYC_DIRECT,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "kycDirectDC", type: WIDGET.KYC_DIRECT }
        ],
    },
    datastore: {
        kycDirectDC: {
            height: height
        }
    },
});
export const kycRedirectMF = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
};
